<div class="flex flex-column column-gap-32" data-cy="Guide docs">
  <h1 *ngIf="titleKey" class="mt-0 fs-24 font-medium text-grey-ultra-dark">{{ titleKey | translate }}</h1>

  <div *ngIf="subtitleKey" class="mb-16">
    <h2 class="fs-18 font-medium text-grey-ultra-dark">{{ subtitleKey | translate }}</h2>
    <p *ngIf="subtitleDescriptionKey" class="mt-4 mb-0 text-grey-dark">{{ subtitleDescriptionKey | translate }}</p>
  </div>

  <div class="flex flex-column column-gap-24">
    <div class="flex flex-row row-gap-16 ion-align-items-center" *ngFor="let doc of docs">
      <div class="m-0 flex-none grid place-content-center w-48 h-48 bg-primary-light text-primary border-radius-full">
        <ion-icon [name]="doc.icon"></ion-icon>
      </div>

      <p class="mt-0 my-0 text-grey-dark" [innerHTML]="doc.descriptionKey | translate"></p>
    </div>
  </div>
</div>
